/**
 * A piece's count option (a limit, how many show at once) as the whole number it stands for, rounded down. The
 * contract checks a number option's range, not that it is whole, and a released number option cannot narrow, so a
 * site's 2.5 counts as 2 wherever a count is used, the reads that take whole numbers included (Codex code review of
 * web-studio-sites group 6, 2026-10-26).
 */
export function wholeCount(n: number): number {
  return Math.floor(n);
}
